export const CLICK_ACTIONS = {
    CLICK_CARD: "click-payment-card",
    CLICK_ADD_NEW_CARD: "click-payment-add-new-card",
    CLICK_FOOD_CARD: "click-payment-food-card",
    CLICK_ADD_NEW_FOOD_CARD: "click-payment-add-new-food-card",
    CLICK_WALLET: "click-payment-wallet",
    CLICK_NETBANKING: "click-payment-netbanking",
    CLICK_UPI_INTENT_METHOD: "click-upi-intent-app",
    CLICK_MORE_BANKS: "click-payment-more-banks",
    CLICK_COD: "click-payment-cod",
    CLICK_FAILURE_OPTION_COD: "click-payment-failure-option-cod",
    CLICK_FAILURE_OPTION_DISMISS: "click-payment-failure-option-dismiss",
    CLICK_FAILURE_OPTION_RETRY: "click-payment-failure-option-retry",
    CLICK_FAILURE_OPTION_WALLET: "click-payment-failure-option-wallet",
    CLICK_WALLET_ADD_MONEY: "click-payment-wallet-add-money",
    CLICK_COUPON_NOT_APPLICABLE_OPTION_DISMISS: "click-coupon-not-applicable-option-dismiss",
    CLICK_COUPON_NOT_APPLICABLE_OPTION_CONTINUE: "click-coupon-not-applicable-option-continue",
    CLICK_SPLIT_PAY: "click-swiggy-pay-optin",
    CLICK_UPI_TIMER_HALF_CARD_CANCEL: "click-cancel-half",
    CLICK_UPI_TIMER_BACK: "click-back",
    CLICK_UPI_TIMER_CANCEL: "click-cancel",
    CLICK_UPI_INTENT_BACK: "click-back",
    CLICK_UPI_INTENT_CANCEL: "click-cancel",
    CLICK_PAYMENT_FAILURE_DIALOG_RETRY_PAYMENT: "click-payment-retry",
    CLICK_CTA_ON_TERMINAL_STATE_ALERT: "click-terminal-state-cta",
    CLICK_PAYMENT_FAILURE_DIALOG_DISMISS_PAYMENT: "click-dismiss",
    CLICK_PAYMENT_FAILURE_DIALOG_TRY_OTHER_PAYMENT: "click-try-others",
    CLICK_LINK_WALLET_VERIFY_AND_PROCEED: "click-verify-and-proceed",
    CLICK_LINK_WALLET_RESEND_OTP: "click-resend-otp",
    CLICK_DUPLICATE_ORDER_DIALOG_ACTION: "click-option-duplicate-order",
    CLICK_SURGE_CHARGE_ORDER_DIALOG_ACTION: "click-option-surge-change",
    CLICK_LINK_WALLET: "click-link-wallet",
    CLICK_LINK_PAYLATER: "click-link-account",
    CLICK_PROCEED_LINK_PAYLATER: "click-confirm-proceed",
    CLICK_VERIFY_PROCEED: "click-verify-proceed",
    CLICK_PROCEED_LINK_WALLET: "click-proceed-link",
    CLICK_SWIGGY_PAY_OPTIN: "click_swiggy_pay_optin",
    CLICK_FLIPKART_COINS_OPTIN: "click_FlipkartCoins_pay_optin",
    CLICK_ADD_MONEY: "click-add-money",
    CLICK_PAYMENT_BANNER: "click-payment-banner",
    CLICK_VIEW_MORE_PAYMENT_OPTIONS: "click-view-more-payment-options",
    CLICK_PAYMENT_GROUP: "click-payment-group",
    CLICK_CRED_PAY: "click_Cred_pay",
    CLICK_CARD_PAY: "click-card-pay",
    CLICK_PAY_BUTTON: "click_pay_button",
    CLICK_SWIGGY_MONEY_INFO_CTA: "click-learn-more",
    CLICK_SWIGGY_MONEY_INFO_HALF_CARD_CLOSE: "click-options",
    CLICK_SWIGGY_ADD_MONEY_WIDGET: "click-swiggy-add-money-widget",
    CLICK_PREDEFINED_RECHARGE_AMOUNT: "click-predefined-recharge-amount",
    CLICK_CUSTOM_RECHARGE_AMOUNT: "click-custom-recharge-amount",
    CLICK_PROCEED_WITH_RECHARGE: "click-proceed-with-recharge",
    CLICK_RECOMMENDED_PAYMENT_METHOD: "click-recommended-payment-method",
    CLICK_LAST_USED_PAYMENT_METHOD: "click-last-used-payment-method",
    CLICK_MORE_PAYMENT_METHODS_HALF_CARD: "click-more-payment-methods",
    CLICK_PROCEED_TO_PAY_HALF_CARD: "click-proceed-to-pay",
    CLICK_TOGGLE_SWIGGY_PAY: "toggle-swiggy-pay",
    CLICK_TRY_OTHER_PAYMENT: "click-try-other-payment",
    CLICK_DELETE_SAVED_CARD: "delete-saved-cards",
    CLICK_DELETE_HALF_CARD_CANCEL: "click-delete-card-cancel",
    CLICK_DISMIISS_DELETE_HALFCARD: "dismiss-card-delete-success-halfcard",
    CLICK_CHECKBOX_SECURE_CARD: "click-checkbox-secure-card",
    CLICK_OPTIONS: "click-options",
    CLICK_PAY_PENNY_DROP: "click-pay-penny-drop-and-secure",
    CLICK_ADD_CARD_PAY: "click-add-card-pay",
    CLICK_SAVE_CHANGES: "click-save-changes",
    CLICK_SAVE_SECURE_CHANGES: "click-save-changes-and-secure",
    CLICK_PAYMENT_HALF_CARD: "click-payment-half-card",
    CLICK_POD: "click-payment-upi-on-delivery",
    CLICK_POD_PAY: "click-upi-on-delivery-pay",
    CLICK_KEY_FACTS_STATEMENT: "click-key-facts-statement",

    CLICK_KNOW_MORE_CARD_TOKENIZATION: "click-know-more-tokenization",
    // Pay on Delivery/AutoPay
    CLICK_PAY_ON_DELIVERY_MAX_PAYMENT_RETRIES: "click-continue-cod",
    CLICK_CONTINUE: "click-continue",
    CLICK_CONTINUE_PAYING: "click-continue-paying",
    CLICK_GOTO_TRACK: "click-go-to-track",
    CLICK_PAY_ON_NEXT_SCREEN: "click-pay-next-screen",
    CLICK_PLACE_ORDER_PAY_ON_NEXT_SCREEN: "click-place-order-and-pay-next-screen",
    CLICK_GO_BACK: "click-go-back",

    // Buttons
    CLICK_PROCEED: "click-proceed",
    CLICK_SKIP_FOR_NOW: "click-skip-for-now",
    CLICK_TERMS_OF_SERVICE: "click-terms-of-service",
    CLICK_GOT_IT: "click-got-it",
    CLICK_CANCEL: "click-cancel",
    CLICK_CLOSE: "click_close",

    //Add Money Delink Wallet
    CLICK_DELINK_WALLET: "click-delink-wallet",
    CLICK_CONFIRM_DELINK: "click-confirm-delink",
    CLICK_CANCEL_DELINK: "click-cancel-delink",
    CLICK_TRY_AGAIN_DELINK: "click-try-again-delink",
    CLICK_CROSS_DELINK_FAILURE: "click-cross-delink-failure",

    // Swiggy money Flow constants
    CLICK_SM_REDEEM_NOW: "click-sm-redeem-now",

    //Turbo Payment
    CLICK_TURBO_PAY: "click-turbo-pay",
    CLICK_CHANGE: "click-change",
    CLICK_SLIDER: "click-slider",
    CLICK_CHANGE_TOOLTIP: "click-change-tooltip-cross",
    CLICK_CASH_ORDER_PLACE: "click-cash-order-place",
    CLICK_CASH_ORDER_CANCEL: "click-cash-order-cancel",

    // Smart UPI Intent
    CLICK_VIEW_ALL: "click-view-all",
    CLICK_ADD_NEW: "click-add-new",
    CLICK_PAYMENT_GROUPS: "click-payment-groups",

    // Payment method in downtime
    CLICK_PAY_AFTER_ORDER: "click-pay-after-order",

    // In AppUPI
    CLICK_PAYMENT_ADD_ONE_TAP: "click-payment-add-1tapupi",

    // splitpay
    CLICK_VIEW_ALL_REWARDS: "click-view-all-rewards",
    CLICK_REWARDS_GROUPS: "click-rewards-groups",
    CLICK_CROSS_REWARD_GROUPS: "click-cross-rewards-groups",

    // webview refresh alert
    CLICK_WEBVIEW_REFRESH_ORDER_MISMATCH_ALERT: "click-webview-refresh-orderid-mismatch-alert-cta",

    // pay using other methods
    CLICK_PAY_USING_OTHER_METHODS: "click-pay-using-other-methods",
    // emi
    CLICK_EMI_EXPAND: "click-emi-dropdown",
    CLICK_EMI_TNC: "click-emi-readmore",
    CLICK_EMI_PROCEED: "click-review-emi",
    CLICK_EMI_OPTION: "click-choose-emi",

    // CARD-CLICK-EMI-CTA
    CLICK_CARD_EMI: "click-card-emi",

    // payment group NC EMI
    CLICK_PAYMENT_GROUP_EMI: "click-payment-group",

    // review bill details
    CLICK_EMI_TNC_REVIEW_BILL_DETAILS: "click-emi-tnc",
    CLICK_EMI_DETAIL_REVIEW_BILL_DETAILS: "click-emi-detail",
    CLICK_PAY_REVIEW_BILL_DETAILS: "click-pay",

    // bill image
    CLICK_BILL_IMAGE_HALF_CARD_PROCEED: "bill-image-half-card-proceed",
    CLICK_BILL_IMAGE_HALF_CARD_DENY: "bill-image-half-card-deny",
    CLICK_BILL_IMAGE_HALF_CARD_CLOSE: "click-bill-image-half-card-close",
};

export const IMPRESSION_ACTIONS = {
    IMPRESSION_PAYMENT_FAILURE: "payment-failure-dialog",
    IMPRESSION_COUPON_NOT_APPLICABLE: "coupon-not-applicable-dialog",
    IMPRESSION_UPI_TIMER_CANCEL_HALF_CARD: "impression-timer-cancel-half-card",
    IMPRESSION_UPI_TIMER: "impression-timer",
    IMPRESSION_UPI_INTENT: "impression-upi-intent-poller-screen",
    IMPRESSION_LINK_WALLET: "impression-link-wallet-otp",
    IMPRESSION_LINK_WALLET_OTP_ERROR: "otp-error",
    IMPRESSION_DUPLICATE_ORDER_DIALOG: "impression-duplicate-order",
    IMPRESSION_SURGE_ORDER_DIALOG: "impression-surge-change-half-card",
    IMPRESSION_UNABLE_TO_FETCH_METHODS: "sorry-unable-to-fetch-payment-options",
    IMPRESSION_PLACE_ORDER_ERROR_POPUP: "place-order-error-popup",
    IMPRESSION_PAYMENT_LIST: "payment-list-impression",
    IMPRESSION_PAYMENT_PAGE: "impression-payment-page-landed", // used by devs for debugging
    IMPRESSION_SWIGGY_MONEY_PAYMENT_LIST: "swiggy-money-payment-list-impression",
    IMPRESSION_ADD_MONEY_WALLET: "impression-add-money",
    IMPRESION_PAYMENT_BANNER: "impression-payment-banner",
    IMPRESSION_MORE_PAYMENT_GROUPS: "more-payment-option-groups",
    IMPRESSION_MORE_PAYMENT_METHODS: "more-payment-option-methods",
    IMPRESSION_ELIGIBLITY_STATUS: "checking_eligibility_status",
    IMPRESSION_ORDER_PLACED: "order_placed",
    IMPRESSION_PAYMENT_GROUP: "impression-payment-group",
    IMPRESSION_PAYMENT_GROUP_TOOLTIP: "impression-payment-group-nudge-payment",
    IMPRESSION_SWIGGY_MONEY_INFO_CTA: "impression-learn-more",
    IMPRESSION_SWIGGY_MONEY_INFO_HALF_CARD: "impression-swiggy-money-limits-halfcard",
    IMPRESSION_ADD_SWIGGY_MONEY_WIDGET: "impression-swiggy-add-money-widget",
    IMPRESSION_PAYMENT_FAILURE_HALF_CARD: "payment-failure-half-card",
    IMPRESSION_RECOMMENDED_PAYMENT_METHOD: "recommended-payment-method",
    IMPRESSION_LAST_USED_PAYMENT_METHOD: "last-used-payment-method",
    IMPRESSION_MORE_PAYMENT_METHODS_HALF_CARD: "more-payment-methods",
    IMPRESSION_TECHNICAL_FAILURE_HALF_CARD: "technical-failure-error",
    IMPRESSION_SWIGGY_MONEY_ADD_MONEY: "swiggy-add-money-screen",
    IMPRESSION_CLOSING_TIMER: "impression_timer",
    IMPRESSION_CLOSING_TIMER_HALF_CARD: "impression_timer",
    IMPRESSION_PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE: "impression-autopay-prev-success",
    IMPRESSION_PAY_ON_DELIVERY_PAST_PAYMENT_PENDING: "impression-autopay-pending",
    IMPRESSION_PAY_ON_DELIVERY_MAX_PAYMENT_RETRIES: "impression-continue-cod",
    IMPRESSION_PAY_ON_DELIVERY_CONTINUE_PAYING: "imp-continue-paying",
    IMPRESSION_PAY_ON_DELIVERY_GOTO_TRACK_SCREEN: "imp-go-to-track",
    IMPRESSION_PAYMENT_HALF_CARD: "impression-payment-half-card",
    IMPRESSION_PAYMENT_ERROR: "impression-payment-error",
    IMPRESSION_LINK_WALLET_SUCCESS: "impression-success-link",
    IMPRESSION_UPI_INTENT_PAYMENT_FAILED: "impression-upi-intent-payment-failed",
    IMPRESSION_SKIP_CVV: "impression-skip-cvv",
    IMPRESSION_CONFIRM_PROCEED: "impression-confirm-proceed",
    IMPRESSION_VERIFY_PROCEED: "impression-verify-proceed",
    IMPRESSION_RESEND_OTP: "impression-resend-otp",
    IMPRESSION_PAYLATER_METHODS: "pay-later-method-impression",
    IMPRESSION_LINK_ACCOUNT: "impression-link-account",
    // Simpl linking failed
    IMPRESSION_SIMPL_LINKING_FAILED: "impression-SIMPL-link-failed",
    //Add Money Delink Wallet
    IMPRESSION_CURRENT_BALANCE: "impression-current-balance",
    IMPRESSION_CONFIRM_DELINK: "impression-confirm-delink",
    IMPRESSION_SUCCESS_DELINK: "impression-success-delink",
    IMPRESSION_FAILED_DELINK: "impression-failed-delink",

    IMPRESSION_MAW_BANNER: "impression-maw-banner", // MAW: Moment at Work

    // croutons on add new card screen
    IMPRESSION_CARD_NOT_ELIGIBLE_CROUTON: "impression-card-na",

    //Turbo Payment
    IMPRESSION_TURBO_PAY: "impression-turbo-pay",
    IMPRESSION_MESSAGE: "impression-msg",
    IMPRESSION_CHANGE_TOOLTIP: "imp-change-tooltip",
    IMPRESSION_CASH_ORDER: "impression-cash-order",

    //payment offer
    IMPRESSION_PAYMENT_OFFER_STRIP: "impression-payment-banner",
    IMPRESSION_UPI_APP: "impression-upi-app",

    // Smart UPI Intent
    IMPRESSION_VIEW_ALL: "impression-view-all",
    IMPRESSION_ADD_NEW: "impression-add-new",
    IMPRESSION_PAYMENT_GROUPS: "impression-payment-groups",
    IMPRESSION_PAYMENT_GROUPS_EXPANDED: "impression-payment-groups-expanded",

    // Payment method in downtime
    IMPRESSION_PAY_AFTER_ORDER: "impression-pay-after-order",

    IMPRESSION_NUDGE_PAY_FLIPKART_COINS: "impression-nudge-pay-FlipkartCoins",
    IMPRESSION_NUDGE_INVALID_FLIPKART_COINS: "impression-nudge-invalid-FlipkartCoins",

    IMPRESSION_PAYMENT_CONFIRMATION_V5: "impression-transition-confirmation-screen",
    IMPRESSION_PAYMENT_CONFIRMATION_V5_BLACK_OTP: "OTG-order-placed-animation-impression",

    IMPRESSION_MWEB_UPI_INTENT_REDIRECT_FAILURE: "impression-mweb-upi-intent-redirect-failure",

    // splitpay
    IMPRESSION_VIEW_ALL_REWARDS: "impression-view-all-rewards",
    IMPRESSION_REWARDS_GROUPS: "impression-rewards-groups",
    IMPRESSION_REWARD_SUCCESSFULLY_APPLIED_TOAST: "toast-rewards-successfully-applied",
    IMPRESSION_SELECT_ONLY_ONE_SPLITPAY_TOAST: "toast-select-only-one-reward",
    // bolt
    IMPRESSION_BOLT_PAYMENT_CONFIRMATION: "impression-payment-confirmation",
    // webview refresh alert
    IMPRESSION_WEBVIEW_REFRESH_ORDER_MISMATCH_ALERT: "impression-webview-refresh-orderid-mismatch-alert",

    IMPRESSION_PAYMENT_CONFIRMATION: "impression-payment-confirmation",

    // Turbo Amount Mismatch (used for dev only)
    IMPRESSION_TURBO_AMOUNT_MISMATCH: "impression-turbo-amount",

    // Bill to Company
    IMPRESSION_BTC_TOGGLE: "impression-btc-toggle",

    // pay using other methods
    IMPRESSION_PAY_USING_OTHER_METHODS: "impression-pay-using-other-methods",
    IMPRESSION_EMI_SELECTION_PAGE: "impression-emi-page-landed",

    // review bill details
    IMPRESSION_REVIEW_BILL_DETAILS: "impression-page-landed",
    IMPRESSION_REVIEW_BILL_DETAILS_FAIL: "impression-page-landed-fail",
    IMPRESSION_TNC_HC: "impression-tnc-hc",
    IMPRESSION_EMI_DETAIL_HC: "impression-emi-detail-hc",

    IMPRESSION_BILL_IMAGE_HALF_CARD: "bill_upload_half_card_add_bill",
    IMPRESSION_PAYMENT_WALLET: "impression-payment-wallet",

    IMPRESSION_PAYMENT_METHOD: "impression-payment-method",
};

export const SCREEN_VIEW_ACTIONS = {
    VIEW_PENNY_DROP_SCREEN: "penny-drop-screen",
    VIEW_CARD_SECURED_SUCCESS: "card-secured-success",
    VIEW_TOKENIZATION_GUIDELINES_HALF_CARD: "tokenization-guidelines-half-card",
    VIEW_MANAGE_CARD_SCREEN: "manage-card-screen",
    VIEW_ADD_NEW_CARD: "impression-add-new-card",
    VIEW_DELETE_HALF_CARD: "delete-saved-cards-halfcard",
    VIEW_DELETE_HALF_CARD_SUCCESS: "card-delete-success-halfcard",
    VIEW_SWIGGY_MONEY_SUCCESS_SCREEN: "swiggy-money-added-success",
    VIEW_LINK_WALLET: "screen-view-link-wallet",
    VIEW_LINK_PAYLATER: "screen-view-link-paylater",
    VIEW_ADD_MONEY_SCREEN: "screen-view-add-money",
    VIEW_AUTOPAY_PAYMENT_FAILURE_SCREEN: "pay-next-screen",
};

export const BILL_IMAGE_HALF_CARD_LABELS = {
    PROCEED: "proceed_to_bill_upload_button",
    DENY: "deny_to_upload_bill",
    CLOSE: "close_button",
};
